import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/** Return state for login/register after unauthenticated cart access */
export const CART_LOGIN_RETURN = {
  pathname: '/dashboard',
  search: '?tab=cart',
};

export function isCartReturnState(from) {
  if (!from || from.pathname !== '/dashboard') return false;
  const search = from.search || '';
  return search === '?tab=cart' || search.includes('tab=cart');
}

/** Same flow as header cart button: dashboard cart or login with return */
export function navigateToCart(navigate) {
  if (localStorage.getItem('token')) {
    navigate('/dashboard?tab=cart');
    return;
  }

  navigate('/login', {
    state: { from: CART_LOGIN_RETURN },
  });
}

/** Legacy /cart URLs → canonical dashboard cart */
export function LegacyCartRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    navigateToCart(navigate);
  }, [navigate]);

  return null;
}
